import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import ReplayTwoToneIcon from '@mui/icons-material/ReplayTwoTone';
import ReplayCircleFilledTwoToneIcon from '@mui/icons-material/ReplayCircleFilledTwoTone';

interface AutoRefreshProps {
  refreshHandler: Function;
  refreshHintMessage?: string;
}

export const AutoRefresh: React.FC<AutoRefreshProps> = ({
  refreshHandler,
  refreshHintMessage,
}) => {
  const [autoRefresh, setAutoRefresh] = useState<boolean>(false);

  const toggleAutoRefresh = () => {
    setAutoRefresh(!autoRefresh);
    refreshHandler();
  };
  return (
    <Tooltip placement="top" arrow title={refreshHintMessage ?? ''}>
      <IconButton onClick={toggleAutoRefresh}>
        {!autoRefresh && <ReplayTwoToneIcon fontSize="small" color="primary" />}
        {autoRefresh && (
          <ReplayCircleFilledTwoToneIcon fontSize="small" color="primary" />
        )}
      </IconButton>
    </Tooltip>
  );
};
